import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { useLenis } from "@/hooks/useLenis";

import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { EmotionalSection } from "@/components/EmotionalSection";
import { Services } from "@/components/Services";
import { Technology } from "@/components/Technology";
import { Gallery } from "@/components/Gallery";
import { Testimonials } from "@/components/Testimonials";
import { TrustSection } from "@/components/TrustSection";
import { AppointmentForm } from "@/components/AppointmentForm";
import { CTAFinal } from "@/components/CTAFinal";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

import { AdminLogin } from "@/pages/AdminLogin";
import { AdminDashboard } from "@/pages/AdminDashboard";

const Landing = () => {
  useLenis();
  return (
    <div data-testid="landing-page" className="bg-white text-[#1A1A1A]">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <EmotionalSection />
        <Services />
        <Technology />
        <Gallery />
        <Testimonials />
        <TrustSection />
        <AppointmentForm />
        <CTAFinal />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LanguageProvider>
            <Toaster
              position="top-center"
              toastOptions={{
                style: {
                  background: "#1A1A1A",
                  color: "#fff",
                  border: "1px solid rgba(212,175,55,0.4)",
                  borderRadius: "12px",
                },
              }}
            />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </LanguageProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
